<template>
  <article id="family-event-wrapper" class="contents-wrapper">
    <router-view />
  </article>
</template>

<script lang="ts">
export default {
  setup() {
    return {};
  },
  data() {
    return {
      title: "",
    };
  },
  methods: {},
  created() {
    console.log("[FamilyEventWrapper] created");
    window.scrollTo(0, 0);
  },
};
</script>

<style lang="scss" scoped></style>
